var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('field-select-module',{attrs:{"board":this.board,"is-print":_vm.isPrint},model:{value:(_vm.form.stdInfo),callback:function ($$v) {_vm.$set(_vm.form, "stdInfo", $$v)},expression:"form.stdInfo"}}),_c('table-custom',{attrs:{"board":_vm.board,"is-print":_vm.isPrint,"title":"관리부서","tableData":[
      { id: 'input1', title: '성명', type: 'text', placeholder: '내용' },
      { id: 'input2', title: '소속(부서명)', type: 'text', placeholder: '내용' },
      {
        id: 'input3',
        title: '담당업무',
        type: 'select',
        selectData: [
          '시설 안전조치',
          '유지보수 업무',
          '기타 안전관리',
        ],
        placeholder: '선택',
      },
      { id: 'input4', title: '연락처', type: 'text', placeholder: '내용' },
    ]},model:{value:(_vm.form.companyList1),callback:function ($$v) {_vm.$set(_vm.form, "companyList1", $$v)},expression:"form.companyList1"}}),_c('table-custom',{attrs:{"board":_vm.board,"is-print":_vm.isPrint,"title":"수탁업체","tableData":[
      { id: 'input1', title: '성명', type: 'text', placeholder: '내용' },
      { id: 'input2', title: '업체명', type: 'text', placeholder: '내용' },
      {
        id: 'input3',
        title: '담당업무',
        type: 'select',
        selectData: [
          '시설 안전조치',
          '유지보수 업무',
          '기타 안전관리',
        ],
        placeholder: '선택',
      },
      { id: 'input4', title: '연락처', type: 'text', placeholder: '내용' },
    ]},model:{value:(_vm.form.companyList2),callback:function ($$v) {_vm.$set(_vm.form, "companyList2", $$v)},expression:"form.companyList2"}}),_c('file-upload-module',{staticClass:"w-full mt-4",attrs:{"id":"fileList","is-print":_vm.isPrint,"readonly":_vm.board.readonly},model:{value:(_vm.form.fileList),callback:function ($$v) {_vm.$set(_vm.form, "fileList", $$v)},expression:"form.fileList"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }